"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIStyle = {
    UIColors: {
        white: '#FFFFFF',
        lightGrey: '#00000029',
        black: '#000000',
        gold: '#E1A87A',
        darkGrey: '#212121',
        mediumGrey: '#5D5D5D',
    },
    Shadows: {
        boxShadow: '0px 6px 6px #00000029',
        boxShadowDeep: '0px 12px 1px #00000029',
        boxShadowImage: '0px 12px 12px #00000029',
    },
};
